// get user system permissions
export const getUserSystemPermissions = (store) => store.userSystemPermissions;

// get user permissions for current application
export const getCurrentAppUserPermissions = (store) => store.currentAppUserPermissions;
